import { HttpClient, HttpParams, HttpHeaders, HttpResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';

// Services
import { SharedDataService } from './shared-data.service';

// Interfaces
import { Simulation, Item } from '../interfaces/simulation';
import { PaymentTerm } from '../interfaces/paymentTerm';
import { VerbaTrade } from '../interfaces/verbaTrade';
import { Message } from '../interfaces/message';
import { Product } from '../interfaces/product';
import { FilterService } from './baseListFilter.service';
import { Customer } from '../interfaces/customer'

@Injectable({
  providedIn: 'root'
})
export class SimulationService extends FilterService {

  // New Simulation
  private errorMessage: Message;
  constructor(
    protected httpClient: HttpClient,
    protected sharedData: SharedDataService,
    private route: Router,
  ) {
    super()
    this.errorMessage = {
      status: 500
      , error: {errorMessage: 'Não Foi Possível Comunicar Com o Servidor!' }
      , ok: false
    }
    console.log('constructor > SimulationService')
  }

  getDataFiltered(params: HttpParams): Observable<HttpResponse<Simulation[]>> {
    return this.httpClient.get<Simulation[]>(`$companyId/simulation/simul`, {observe: 'response', params})
  }

  // Edit Simulation
  loadSimulationData(simulationId: any, tenantId?: any): Observable<Simulation> {
    if(tenantId) {
      const company = tenantId?.slice(0, 2) + "," + tenantId?.slice(2)
      const headers = new HttpHeaders().set('tenantId', company)
      return this.httpClient.get<any>(`$companyId/simulation/simul/${simulationId}`, { headers })
    } else {
      return this.httpClient.get<any>(`$companyId/simulation/simul/${simulationId}`)
    }
  }
  

  // New Simulation
  fetchCustomerData(value: string): Observable<Customer[]> {
    const params = this.handleParams({
      filter: value
    }
    )
    return this.handleGetRequestWithQueryParams('$companyId/customer', params)
  }


  saveSimulation(data: Simulation): Observable<Simulation> {
    const url = '$companyId/simulation/savesimul';
    const simulation = new Subject<Simulation>();

    this.httpClient.post<Simulation>(url, data, {observe: 'response'}).subscribe(
      response => {
        this.httpClient.get<Simulation>(response.headers.get('Location')).subscribe(
          simul => {
            console.log('simulation.service.saveSimulation()', simul)
            simulation.next(simul);
          }, error => {
            simulation.error(error.status === 0 ? this.errorMessage : error)
          }
        )
      }, error => {
        simulation.error(error.status === 0 ? this.errorMessage : error)
      }
    )
    return simulation.asObservable();
  }

  generateOrder(data: Simulation): Observable<Message> {
    const url = '$companyId/simulation/saveorder'
    const message =  new Subject<Message>();
    this.httpClient.post<Message>(url, data).subscribe(
      order => {
        message.next(order)
      }, error => {
        message.error(error.status === 0 ? this.errorMessage : error)
      }
    )
    return message.asObservable()
  }

  // Common Function
  calculate(productData: Simulation): Observable<Simulation> {
    const url = '$companyId/simulation/calculate'
    const simul = new Subject<Simulation>();
    this.httpClient.post<Simulation>(url, productData).subscribe(
      data => {
        simul.next(data)
      }, error => {
        simul.error(error.status === 0 ? this.errorMessage : error)
      }
    )
    return simul.asObservable();
  }

  fetchPaymentData(simulation?: Simulation): Observable<PaymentTerm[]> {
    const url = '$companyId/paymentTerm'
    if (this.route.url.match('simulation')){
      const params = this.handleParams({
        sellerId: simulation.customer.sellerId?.trim()
      })
      return this.handleGetRequest(url, params)
    }
    return this.handleGetRequest(url)
  }

  fetchVerbaTrandingData(): Observable<VerbaTrade[]> {
    const url = '$companyId/finverba'
    return this.handleGetRequest(url)
  }

  handleDeleteSimulation(simulId: string): Observable<Message> {
    const url = `$companyId/simulation/simul/${simulId}`
    const message =  new Subject<Message>();
    this.httpClient.delete<Message>(url).subscribe(
      data => {
        message.next(data)
      }, error => {
        message.error(error.status === 0 ? this.errorMessage : error)
      }
    )
    return message.asObservable()
  }

  fetchProductData(simulation: Simulation): Observable<Product[]> {
    const url = '$companyId/priceTable'
    const params = this.handleParams({
      customerId: simulation.customer['customerId'],
      freightType: simulation.freightType,
      pricetableId: simulation.customer['priceTableId'],
      storeId: simulation.customer['storeId'],
    }
    );

    return this.handleGetRequestWithQueryParams(url, params)
  }

  approveSimulation(data: Simulation, tenantId?: any): Promise<any> {
    const url = '$companyId/simul/approve'
    if(tenantId) {
      const company = tenantId?.slice(0, 2) + "," + tenantId?.slice(2)
      const headers = new HttpHeaders().set('tenantId', company)
      return this.httpClient.post<Simulation>(url, data, {headers, observe: 'response'}).toPromise()
    } else {
      return this.httpClient.post<Simulation>(url, data, {observe: 'response'}).toPromise()
    }
  }

  repproveSimulation(data: Simulation, tenantId?: any): Promise<any> {
    const url = '$companyId/simul/reprove'
    if(tenantId) {
      const company = tenantId?.slice(0, 2) + "," + tenantId?.slice(2)
      const headers = new HttpHeaders().set('tenantId', company)
      return this.httpClient.post<Simulation>(url, data, {headers, observe: 'response'}).toPromise()
    } else {
      return this.httpClient.post<Simulation>(url, data, {observe: 'response'}).toPromise()
    }
  }

  handleParams(paramsFields) {
    let params = new HttpParams()
    console.log('paramsfields', JSON.stringify(paramsFields))
    Object.entries(paramsFields).forEach((entrie: any) => {
      params = params.append(entrie[0], entrie[1])
    })
    return params
  }

  handleGetRequestWithQueryParams(url: string, params: HttpParams): Observable<any> {
    return this.httpClient.get<any>(url, { params })
  }

  handleGetRequest(url: string, params?: HttpParams): Observable<any> {
    return this.httpClient.get<any>(url, { params })
  }

  handleWarnings(customerId: string, storeId: string): Observable<any> {
    return this.httpClient.get<any>(`$companyId/avisos/${customerId}/${storeId}`)
  }

  requestSellOut(body: any) {
    return this.httpClient.post<any>(`$companyId/sellout`, body)
  }

  fetchProductData2(simulation: Simulation): Observable<Product[]> {
    const url = '$companyId/priceTable2'
    const params = this.handleParams({
      customerId: simulation.customer['customerId'],
      freightType: simulation.freightType,
      pricetableId: simulation.customer['priceTableId'],
      storeId: simulation.customer['storeId'],
    });

    return this.handleGetRequestWithQueryParams(url, params)
  }

}
